// IMPORTANT: These colors must jive with the colors in scss/_colors.scss.
// If you are adding a color there, you must add it here.
export const colorVars = {
  // branding
  utkColorAdcDarkGreen: '#297708',
  utkColorAdcLightGreen: '#77bc1f',
  utkColorAdcLightBlue: '#57c1e8',

  // accents
  utkColorNavyBlue: '#345771',
  utkColorAquaBlue: '#377a93',
  utkColorCloudBlue: '#f5faff',

  // grayscale
  utkColorBlack: '#000102',
  utkColorNearBlack: '#333',
  utkColorGrayDark: '#263238',
  utkColorGray: '#5c676e',
  utkColorGrayMedium: '#97a0a6',
  utkColorGrayMediumLight: '#c0c8cc',
  utkColorGraySemantic: '#d3d3d3',
  utkColorGrayLight: '#dae0e3',
  utkColorGrayExtraLight: '#e9ecee',
  utkColorOffWhiteDark: '#f0f2f4',
  utkColorOffWhite: '#f8f9fa',
  utkColorWhite: '#fff',

  // state
  utkColorInfo: '#036eb5',
  utkColorInfoLight: '#e4f7fd',
  utkColorSuccess: '#297708',
  utkColorSuccessLight: '#edf3e7',
  utkColorCaution: '#bd4000',
  utkColorCautionLight: '#fff2ee',
  utkColorError: '#c30000',
  utkColorErrorLight: '#fce4e5',
  utkColorAlert: '#f15c2c',
  utkColorAlertLight: '#fef0eb',

  // misc
  utkColorAdcDarkGreen60: 'rgba(41, 119, 8, .6)',
  utkColorAdcLightGreen60: 'rgba(119, 188, 31, .6)',
  utkColorAdcLightBlue60: 'rgba(87, 193, 232, .6)',
  utkColorInfo60: 'rgba(3, 110, 181, .6)',
  utkColorInfoExtraLight: '#f0fbfe',
  utkColorAquaBlue60: 'rgba(55, 122, 147, .6)',
  utkColorNavyBlue60: 'rgba(52, 87, 113, .6)',
  utkColorBlack60: 'rgba(0, 1, 2, .6)',
  utkColorGrayDark60: 'rgba(38, 50, 56, .6)',
  utkColorDarkCobalt: '#28397f',
  utkColorPurple: '#6a277a',
  utkColorAdcLightPurple: '#a639bc',
  utkColorPurpleExtraLight: '#fbecfe',
  utkColorError30: 'rgba(195, 0, 0, .3)',
  utkColorSunYellow: '#fed000',
  utkColorSalmon: '#eb5353',

  utkColorTransparent: 'transparent',
}

export enum ColorNames {
  // branding
  AdcDarkGreen = 'adcDarkGreen',
  AdcLightGreen = 'adcLightGreen',
  AdcLightBlue = 'adcLightBlue',
  // accents
  NavyBlue = 'navyBlue',
  AquaBlue = 'aquaBlue',
  CloudBlue = 'cloudBlue',
  // grayscale
  Black = 'black',
  NearBlack = 'nearBlack',
  GrayDark = 'grayDark',
  Gray = 'gray',
  GrayMedium = 'grayMedium',
  GrayMediumLight = 'grayMediumLight',
  GraySemantic = 'graySemantic',
  GrayLight = 'grayLight',
  GrayExtraLight = 'grayExtraLight',
  OffWhiteDark = 'offWhiteDark',
  OffWhite = 'offWhite',
  White = 'white',
  // state
  Info = 'info',
  InfoLight = 'infoLight',
  Success = 'success',
  SuccessLight = 'successLight',
  Caution = 'caution',
  CautionLight = 'cautionLight',
  Error = 'error',
  ErrorLight = 'errorLight',
  Alert = 'alert',
  AlertLight = 'alertLight',
  // misc
  AdcDarkGreen60 = 'adcDarkGreen60',
  AdcLightGreen60 = 'adcLightGreen60',
  AdcLightBlue60 = 'adcLightBlue60',
  Info60 = 'info60',
  InfoExtraLight = 'infoExtraLight',
  AquaBlue60 = 'aquaBlue60',
  NavyBlue60 = 'navyBlue60',
  Black60 = 'black60',
  GrayDark60 = 'grayDark60',
  DarkCobalt = 'darkCobalt',
  Purple = 'purple',
  AdcLightPurple = 'adcLightPurple',
  PurpleExtraLight = 'purpleExtraLight',
  Error30 = 'error30',
  SunYellow = 'sunYellow',
  Salmon = 'salmon',

  Transparent = 'transparent',
}
